import React from 'react';
import Select from '@material-ui/core/Select';
import { FormControl, MenuItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    width: 80,
    marginLeft: 8,
    marginRight: 8,
    '& .MuiSelect-select': {
      padding: '8px 16px 8px',
    },
  },
}));

function SelectYesNoAll({ value = 2, onChange = () => {}, label = '' }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body1" className="ml-4" component="span">
        {label}
      </Typography>
      <FormControl variant="outlined" className={classes.select}>
        <Select
          labelId="select-showInEventLookup"
          id="demo-simple-select-outlined"
          value={value}
          onChange={(ev) => onChange(ev.target.value)}>
          <MenuItem value={2}>All</MenuItem>
          <MenuItem value={1}>Yes</MenuItem>
          <MenuItem value={0}>No</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}

export default SelectYesNoAll;
